import { UserStatus, RoleName } from '../../api-client';

// Конвертируем строковые значения в enum значения
export const stringToUserStatus = (status: string): UserStatus | undefined => {
  switch (status.toLowerCase()) {
    case 'active':
      return UserStatus.ACTIVE;
    case 'pending':
      return UserStatus.PENDING;
    case 'blocked':
      return UserStatus.BLOCKED;
    default:
      return undefined;
  }
};

export const stringToRoleName = (role: string): RoleName | undefined => {
  switch (role.toLowerCase()) {
    case 'user':
      return RoleName.USER;
    case 'admin':
      return RoleName.ADMIN;
    case 'accountant':
      return RoleName.ACCOUNTANT;
    case 'hr':
      return RoleName.HR;
    case 'recruiter':
      return RoleName.RECRUITER;
    case 'lawyer':
      return RoleName.LAWYER;
    default:
      return undefined;
  }
};

// Обратная конвертация
export const userStatusToString = (status: UserStatus): string => {
  switch (status) {
    case UserStatus.ACTIVE:
      return 'active';
    case UserStatus.PENDING:
      return 'pending';
    case UserStatus.BLOCKED:
      return 'blocked';
    default:
      return '';
  }
};

export const roleNameToString = (role: RoleName): string => {
  switch (role) {
    case RoleName.USER:
      return 'user';
    case RoleName.ADMIN:
      return 'admin';
    case RoleName.ACCOUNTANT:
      return 'accountant';
    case RoleName.HR:
      return 'hr';
    case RoleName.RECRUITER:
      return 'recruiter';
    case RoleName.LAWYER:
      return 'lawyer';
    default:
      return '';
  }
};
